/**
 * Maps a log/issue level string to a MUI Chip color prop.
 * Used in both the Sentry issue list and the Datadog log event table.
 */

export type ChipColor = 'error' | 'warning' | 'info' | 'default';

export function levelChipColor(level: string): ChipColor {
  switch (level) {
    case 'fatal':
    case 'error':
      return 'error';
    case 'warning':
      return 'warning';
    case 'info':
      return 'info';
    default:
      return 'default';
  }
}
